import React from 'react';

// Components.
import { Card, CardBody, CardText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import VerifiedContent from '../VerifiedContent';


function CongratulationsContent({ isBetaRolesPage = false, roleData: { title = '', discordInviteCode } = {}, gotoRolesPage = () => null }) {
  return (
    <div>
        {isBetaRolesPage && (
            <Card className="mb-3 shadow-xs border-primary-orange-subtle surface-elevated">
                <CardBody className="panel-card-body py-4">
                    <div className="d-flex flex-column align-items-center gap-2">
                        <div>
                            <div className="text-secondary text-uppercase anton-regular">
                                You&apos;re locked in as
                            </div>
                            <div className="display-5 my-2 text-light fw-normal sigmar-regular lh-1" style={{ letterSpacing: '0.15rem'}}>
                                {title}
                            </div>
                        </div>

                        <CardText className="mb-0 text-secondary">
                            <strong>Next: </strong>
                            Join the Discord to finish onboarding
                        </CardText>

                        <a
                            href={`https://discord.gg/${discordInviteCode}`}
                            rel="noreferrer"
                            target="_blank"
                            className="btn btn-discord btn-lg fw-semibold px-4"
                        >
                            <div className="d-flex justify-content-center align-items-center gap-2">
                                <FontAwesomeIcon
                                    icon={faDiscord}
                                    size="lg"
                                    className="discord-icon"
                                />
                                <span>Enter Discord</span>
                            </div>
                        </a>

                        <small className="text-danger text-uppercase">You can only join 1 beta role per beta phase.</small>
                    </div>
                </CardBody>
            </Card>
        )}

        <div>
            <VerifiedContent isBetaRoleCardShown={!isBetaRolesPage} gotoRolesPage={gotoRolesPage} />
        </div>
    </div>
  );
}

export default CongratulationsContent;
